

<div class="colFlex">
    <div class="bottomLogo "></div>
    <div class="rowFlex">
        <a aria-label="facebook" href={{config?.facebook}} class="socialMediaFacebook"></a>
        <a aria-label="instagram" href={{config?.instagram}} class="socialMediaInstagram"></a>
        <a aria-label="youtube" href={{config?.youtube}} class="socialMediaYouTube"></a>
        <a aria-label="twitter" href={{config?.twitter}} class="socialMediaTwitter"></a>
    </div>
    <p 
      class="regularText copyright" 
      >
        {{config?.copyright}}

      </p>
</div>